<template>
	<v-container>
		<v-row class="contentRow">
			<v-col cols="12">
				<h1 class="mb-2">Add Action Plan</h1>
			</v-col>

			<v-col align="center">
				<v-form v-model="valid">
					<v-col>
						<v-col>
							<v-text-field outlined width="50%" label="Mitigation" v-model="Mitigation" :rules="[rules.inputRules]" />
						</v-col>
						<v-col>
							<v-text-field outlined width="50%" label="Description" v-model="Description"
								:rules="[rules.inputRules, rules.maxWords]" />
						</v-col>
						<v-col>
							<v-text-field outlined width="50%" label="Connected to risk" v-model="Connected_to_risk"
								:rules="[rules.inputRules]" />
						</v-col>
						<!-- <v-col>
							<v-text-field outlined label="Status" v-model="Status" :rules="[rules.inputRules]" />
						</v-col> -->
						<v-col>
							<v-select
								label="Status"
								v-model="Status"
								:items="options"
								item-value="id"
								:rules="[rules.inputRules]"
								outlined
							>
							</v-select>
						</v-col>
						<v-col>
							<v-text-field outlined label="Assigned" v-model="Assigned"
								:rules="[rules.inputRules]" />
						</v-col>
						<v-col>
							<v-text-field type="date" outlined label="Created" v-model="Created" :rules="[rules.inputRules]" />
						</v-col>
						<v-col>
							<v-text-field type="date" outlined label="Expired date"
								v-model="ExpiryDate" :rules="[rules.inputRules]" />
						</v-col>
						<!-- <v-col>
						<v-alert color="primary" type="info">
							Note: <b>{{ (risk || riskdescription) ? risk + " " + riskdescription : "The new user" }}</b> must
							verify their e-mail address before logging in. A verification e-mail will be sent to
							<b>{{ typesofrisk || "their e-mail" }}</b> when you click 'Add user'
						</v-alert>
					</v-col> -->
						<v-col>
							<v-btn class="mr-10" color="primary"
								@click="addAction(Mitigation, Description, Connected_to_risk, Status, Assigned, Created, ExpiryDate)"
								:disabled="!valid">
								Add Action Plan</v-btn>
								<v-btn class="mr-10" color="primary"
								to="riskpage"
								:disabled="!valid">
								Back to RiskPage</v-btn>
						</v-col>
					</v-col>
				</v-form>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { actionplanAPI } from "../api/csr/actionplan"
import LoadingState from "../consts/LoadingState"

export default {
	name: "Add user",
	data() {
		return {
			show: false,
			valid: false,
			valid2: false,
			Connected_to_risk: "",
			Status: 0,
			ExpiryDate: "",
			Assigned: "",
			Created: "",
			Mitigation: "",
			Description: "",
			probability: null,
			rules: {
				inputRules: v => !!v || "Field is required!",
				maxWords: v => (v.split(/\s+/).length <= 30) || "Risk description can only contain up to 30 words"
			},
			options: [
				{ id: 1, text: "Done"},
				{ id: 2, text: "Started"},
				{ id: 3, text: "Planned"}
			],
		}
	},
	computed: {
		matrixID() {
			return this.$route.query.matrixID || null
		}
	},
	mounted() {
		console.log("ID in the Add New Risk:", this.matrixID) // Log the matrixID to the console
		this.$store.commit("setSelectedNewstate", true)
	},
	methods: {
		addAction(Mitigation, Description, Connected_to_risk, Status, Assigned, Created, ExpiryDate) {
			console.log("add action clicked")
			alert("Action Plan Added!")
			// this.$store.dispatch(
			// 	"loading/" + LoadingState.ACTION_START_LOADING,
			// 	{ root: true }
			// )
			actionplanAPI.createAction(this.matrixID,Mitigation, Description, Connected_to_risk, Status, Assigned, Created, ExpiryDate)
			console.log("create action api called")
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Sucessfully added Action!",
						{ root: true }
					)
					this.$router.push({
						name: "Users List"
					})
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
	}
}
</script>